
<!-- 月票管理-新增/编辑月票凭证 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {

				},
				responseCode: {
					"data": {
					  "certifiId":1,
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台月票管理-新增/编辑月票凭证",
					t_url: this.commonUrls.test + "monthTicketCertifiRuleSave",
					p_url: this.commonUrls.prod + "monthTicketCertifiRuleSave",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'certifiId',info2: '否',info3: 'Long',info4: '月票凭证ID（编辑时必填）'},
							{info1: 'certifiName',info2: '是',info3: 'String',info4: '凭证名称'},
							{info1: 'certifiDesc',info2: '否',info3: 'String',info4: '凭证说明'},
							{info1: 'certifiSample',info2: '否',info3: 'String',info4: '凭证样例图片 base64（单个凭证样例时必填）'},
							{info1: 'agreementId',info2: '是',info3: 'Long',info4: '车场协议ID（新平台的停车场不用填）'},
							{info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号（新平台的停车场必填）'},
							{info1: 'monthTicketConfigIds',info2: '否',info3: 'List',info4: '适用月票类型ID 列表（新平台的停车场必填）'},
							{info1: 'needMobile',info2: '否',info3: 'Integer',info4: '是否需要手机号码 0不需要 1需要, 默认0（新平台的停车场可配置）'},
							{info1: 'needOwnerName',info2: '否',info3: 'Integer',info4: '是否需要车主姓名 0不需要 1需要, 默认0（新平台的停车场可配置）'},
							{info1: 'voucherDetails',info2: '否',info3: 'JSONArray',info4: '审核列表（新平台的停车场, 多个凭证样例时必填）'},
					 ]
					},{
            titleName: "voucherDetails审核列表",
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'id', info2: '否', info3: 'Long', info4: '凭证详细id' },
              { info1: 'approveName', info2: '是', info3: 'String', info4: '凭证详细名称' },
              { info1: 'sampleUrl', info2: '是', info3: 'String', info4: '示例url' },
              { info1: 'desc', info2: '否', info3: 'String', info4: '描述' },
            ]
          }
          ],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
									{ info1: 'certifiId', info2: '是', info3: 'Integer', info4: '凭证id' },

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/monthTicketCertifiRuleSave.vue